<form [ngClass]="{'needs-validation': !_submitted, 'was-validated': _submitted}"
      novalidate #frm="ngForm" class="dispute-form">
  <div class="dispute-shell" *ngIf="pedido.disputa">
    <section class="dispute-alert" *ngIf="!pedido.disputa.finalizada">
      <div class="dispute-alert-title">
        <span class="dispute-alert-icon"><i class="fas fa-times"></i></span>
        <h3>Cliente relatou problemas com o pedido</h3>
      </div>

      <div class="dispute-reason" *ngIf="pedido.disputa.justificativa">
        <span>Motivo da solicitação:</span>
        <strong>“{{pedido.disputa.justificativa}}”</strong>
      </div>
    </section>

    <section class="dispute-section dispute-result dispute-result-top" *ngIf="pedido.disputa.finalizada">
      <div class="dispute-section-title">
        <span class="dispute-section-icon dispute-section-icon-green"><i class="far fa-check-circle"></i></span>
        <h4>Disputa encerrada</h4>
      </div>
      <ng-container *ngIf="pedido.disputa.cellcoinChargeback">
        <p *ngIf="pedido.disputa.statusChargeback">
          Status final: <strong>{{rotuloStatusChargebackCellcoin(pedido.disputa.statusChargeback)}}</strong>
        </p>
        <p *ngIf="pedido.disputa.motivoRejeicao">{{pedido.disputa.motivoRejeicao}}</p>
      </ng-container>
      <ng-container *ngIf="!pedido.disputa.cellcoinChargeback">
        <p *ngIf="pedido.disputa.resultadoDisputa === 'ACCEPTED'">A loja concordou com a solicitação.</p>
        <p *ngIf="pedido.disputa.resultadoDisputa === 'REJECTED'">A loja não concordou com a solicitação.</p>
        <p *ngIf="pedido.disputa.resultadoDisputa === 'ALTERNATIVE_REPLIED'">A loja propôs outra solução.</p>
        <p *ngIf="pedido.disputa.motivoRejeicao">Resposta da loja: “<strong>{{pedido.disputa.motivoRejeicao}}</strong>”</p>
        <p *ngIf="!pedido.disputa.resultadoDisputa">Nenhum resultado foi registrado dentro do prazo.</p>
      </ng-container>
    </section>

    <section class="dispute-section" *ngIf="pedido.disputa.cancelamentoParcial || pedido.disputa.cancelamento || pedido.disputa.reembolso">
      <div class="dispute-section-title">
        <span class="dispute-section-icon dispute-section-icon-red"><i class="fas fa-exclamation-circle"></i></span>
        <h4>Solicitação do cliente</h4>
      </div>
      <p class="dispute-request-text" *ngIf="pedido.disputa.cancelamentoParcial">
        Cliente solicitou um cancelamento parcial do pedido.
      </p>
      <p class="dispute-request-text" *ngIf="pedido.disputa.cancelamento">
        Cliente solicitou o cancelamento do pedido.
      </p>
      <p class="dispute-request-text" *ngIf="pedido.disputa.reembolso">
        Cliente solicitou o reembolso do pedido.
      </p>
    </section>

    <section class="dispute-section" *ngIf="pedido.disputa.itens?.length || pedido.disputa.complementos?.length">
      <div class="dispute-section-title">
        <span class="dispute-section-icon"><i class="fas fa-box-open"></i></span>
        <h4>Itens com problema</h4>
      </div>

      <div class="dispute-items" *ngIf="pedido.disputa.itens?.length">
        <article class="dispute-item" *ngFor="let item of pedido.disputa.itens">
          <div>
            <strong>{{item.quantity}}x {{item.descricao}}</strong>
            <span>Problema: “{{item.reason}}”</span>
          </div>
          <b>{{(item.amount.value / 100) | currency: 'BRL'}}</b>
        </article>
      </div>

      <div class="dispute-items" *ngIf="pedido.disputa.complementos?.length">
        <article class="dispute-item" *ngFor="let item of pedido.disputa.complementos">
          <div>
            <strong>{{item.quantity}}x {{item.nome}} <small *ngIf="item.externalCode">· Cód. {{item.externalCode}}</small></strong>
            <span>Problema: “{{item.reason}}”</span>
          </div>
          <b>{{(item.amount.value / 100) | currency: 'BRL'}}</b>
        </article>
      </div>
    </section>

    <section class="dispute-section" *ngIf="pedido.disputa.evidencias?.length">
      <div class="dispute-section-title">
        <span class="dispute-section-icon dispute-section-icon-green"><i class="far fa-images"></i></span>
        <h4>Fotos enviadas pelo cliente</h4>
      </div>
      <div class="dispute-evidence-grid">
        <button type="button" class="dispute-evidence" *ngFor="let evidencia of pedido.disputa.evidencias"
                (click)="verImagem(evidencia.urlPromokit)" title="Ampliar imagem">
          <img [src]="evidencia.urlPromokit" alt="Evidência enviada pelo cliente">
        </button>
      </div>
    </section>

    <section class="dispute-section dispute-cellcoin-summary" *ngIf="pedido.disputa.cellcoinChargeback">
      <div class="dispute-section-title">
        <span class="dispute-section-icon"><i class="far fa-credit-card"></i></span>
        <h4>Disputa de cartão Cellcoin</h4>
        <button type="button" class="dispute-sync-action" (click)="sincronizeChargeback()"
                *ngIf="!pedido.disputa.finalizada"
                [disabled]="sincronizandoChargeback" title="Sincronizar status na Cellcoin">
          <i class="k-i-loading k-icon" *ngIf="sincronizandoChargeback"></i>
          <i class="fas fa-sync-alt" *ngIf="!sincronizandoChargeback"></i>
          Sincronizar
        </button>
      </div>

      <div class="dispute-state-message dispute-state-success" *ngIf="mensagemSincronizacaoChargeback">
        <i class="fas fa-check-circle"></i>
        {{mensagemSincronizacaoChargeback}}
      </div>

      <dl class="dispute-details">
        <div *ngIf="pedido.disputa.finalizada && (pedido.disputa.motivoChargeback || pedido.disputa.justificativa)">
          <dt><i class="fas fa-exclamation-circle"></i>Motivo da solicitação</dt>
          <dd>{{pedido.disputa.motivoChargeback || pedido.disputa.justificativa}}</dd>
        </div>
        <div *ngIf="pedido.disputa.statusChargeback">
          <dt><i class="fas fa-layer-group"></i>Status na Cellcoin</dt>
          <dd><span class="dispute-status">{{rotuloStatusChargebackCellcoin(pedido.disputa.statusChargeback)}}</span></dd>
        </div>
        <div *ngIf="pedido.disputa.codigoPagamento">
          <dt><i class="far fa-credit-card"></i>Cobrança</dt>
          <dd>{{pedido.disputa.codigoPagamento}}</dd>
        </div>
        <div *ngIf="pedido.disputa.codigoTransacao">
          <dt><i class="fas fa-briefcase"></i>Transação</dt>
          <dd>{{pedido.disputa.codigoTransacao}}</dd>
        </div>
        <div *ngIf="pedido.disputa.taxaDisputa">
          <dt><i class="far fa-clock"></i>Taxa de abertura da disputa</dt>
          <dd>{{pedido.disputa.taxaDisputa | currency: 'BRL'}}</dd>
        </div>
      </dl>

      <div class="dispute-info" *ngIf="pedido.disputa.podeResponderChargeback">
        <i class="fas fa-info-circle"></i>
        <span>
          Envie até 10 documentos em PDF ou JPG para defender a transação.<br>
          PDFs devem ter até 2 MB e imagens JPG até 5 MB. Para incluir uma explicação, anexe-a em PDF.
        </span>
      </div>

      <div class="dispute-sent-files" *ngIf="pedido.disputa.documentosEnviados?.length">
        <strong>Documentos enviados</strong>
        <div class="dispute-file" *ngFor="let documento of pedido.disputa.documentosEnviados">
          <i class="far fa-file-alt"></i>
          <span>{{documento.nome}}</span>
          <small>{{formateTamanhoDocumento(documento.tamanho)}}</small>
        </div>
      </div>

      <div class="dispute-state-message dispute-state-info"
           *ngIf="pedido.disputa.documentacaoEnviada && !pedido.disputa.finalizada">
        <i class="fas fa-hourglass-half"></i>
        Documentação enviada para análise da Cellcoin.
      </div>
      <div class="dispute-state-message"
           *ngIf="pedido.disputa.desistenciaSolicitada && !pedido.disputa.finalizada">
        <i class="far fa-flag"></i>
        Desistência enviada. Aguarde a atualização final da Cellcoin.
      </div>
    </section>

    <section class="dispute-section dispute-upload"
             *ngIf="pedido.disputa.cellcoinChargeback && pedido.disputa.podeResponderChargeback">
      <div class="dispute-section-title">
        <span class="dispute-section-icon dispute-section-icon-green"><i class="far fa-file-alt"></i></span>
        <h4>Enviar documentação</h4>
      </div>

      <div class="dispute-file-picker">
        <label for="documentosChargeback" class="dispute-file-button">
          <i class="fas fa-upload"></i>
          Escolher arquivos
        </label>
        <input id="documentosChargeback" type="file" multiple accept=".pdf,.jpg,.jpeg"
               (change)="selecioneDocumentosChargeback($event)">
        <span>{{documentosChargeback.length ? documentosChargeback.length + ' arquivo(s) selecionado(s)' : 'Nenhum arquivo escolhido'}}</span>
      </div>
      <small class="dispute-file-help">Até 10 arquivos. PDF com no máximo 2 MB e JPG com no máximo 5 MB.</small>

      <div class="dispute-selected-files" *ngIf="documentosChargeback.length">
        <div class="dispute-file" *ngFor="let documento of documentosChargeback; let i = index">
          <i class="far fa-file-alt"></i>
          <span>{{documento.nome}}</span>
          <small>{{formateTamanhoDocumento(documento.tamanho)}}</small>
          <button type="button" title="Remover arquivo" (click)="removaDocumentoChargeback(i)" [disabled]="processando">
            <i class="fas fa-times"></i>
          </button>
        </div>
      </div>

      <button type="button" class="dispute-primary-action" (click)="envieDocumentacaoChargeback()"
              [disabled]="processando || !documentosChargeback.length">
        <i class="k-i-loading k-icon" *ngIf="processando"></i>
        <i class="fas fa-paper-plane" *ngIf="!processando"></i>
        Enviar documentação
      </button>
      <button type="button" class="dispute-secondary-action"
              (click)="confirmeDesistirChargeback()" [disabled]="processando">
        <i class="fas fa-shield-alt"></i>
        Não vou contestar
      </button>
    </section>

    <section class="dispute-section dispute-confirmation"
             *ngIf="pedido.disputa.cellcoinChargeback && pedido.disputa.podeResponderChargeback && pedido.confirmarDesistirChargeback">
      <div class="dispute-section-title">
        <span class="dispute-section-icon dispute-section-icon-red"><i class="fas fa-exclamation-triangle"></i></span>
        <h4>Confirmar desistência</h4>
      </div>
      <p>Ao desistir, a loja não enviará defesa. A Cellcoin concluirá o chargeback conforme o fluxo da bandeira.</p>
      <div class="form-group">
        <label for="motivoDesistenciaChargeback">Motivo <span class="text-muted">(opcional)</span></label>
        <textarea class="form-control" id="motivoDesistenciaChargeback" name="motivoDesistenciaChargeback"
                  maxlength="255" rows="2" [(ngModel)]="motivoDesistenciaChargeback"
                  placeholder="Informe o motivo da desistência"></textarea>
      </div>
      <div class="dispute-inline-actions">
        <button type="button" class="btn btn-danger" (click)="desistaChargeback()" [disabled]="processando">
          <i class="k-i-loading k-icon" *ngIf="processando"></i>
          Confirmar desistência
        </button>
        <button type="button" class="btn btn-outline-secondary" (click)="volteDesistirChargeback()"
                [disabled]="processando">Voltar</button>
      </div>
    </section>

    <ng-container *ngIf="!pedido.disputa.cellcoinChargeback && !pedido.disputa.finalizada && !pedido.disputa.aguardandoProposta">
      <section class="dispute-section dispute-deadline">
        <div class="dispute-section-title">
          <span class="dispute-section-icon"><i class="far fa-clock"></i></span>
          <h4>Prazo para resposta</h4>
        </div>
        <div class="dispute-countdown" *ngIf="minutosRestantes <= 15">
          <span>Tempo restante</span>
          <strong>{{tempoRestante}}</strong>
        </div>
        <p *ngIf="minutosRestantes > 15">
          Responda até <strong>{{pedido.disputa.dataExpiracao | date: 'dd MMM HH:mm'}}</strong>.
        </p>
        <div class="dispute-info" *ngIf="pedido.disputa.acaoPadraoReembolsar">
          <i class="fas fa-info-circle"></i>
          <span>Caso não responda a tempo, o valor será automaticamente reembolsado ao cliente no <strong>{{pedido.origem}}</strong>.</span>
        </div>
        <div class="dispute-info" *ngIf="!pedido.disputa.acaoPadraoReembolsar">
          <i class="fas fa-info-circle"></i>
          <span>Caso não responda a tempo, o cliente ainda poderá solicitar o cancelamento pelo <strong>{{pedido.origem}}</strong>.</span>
        </div>
      </section>

      <section class="dispute-section" *ngIf="!pedido.confirmarRejeitarDisputa && !pedido.proposta">
        <div class="dispute-section-title">
          <span class="dispute-section-icon dispute-section-icon-green"><i class="far fa-comment-dots"></i></span>
          <h4>Responder solicitação</h4>
        </div>
        <div class="dispute-action-stack">
          <button type="button" class="dispute-primary-action" (click)="pedido.proposta = {}"
                  [disabled]="processando" *ngIf="pedido.disputa.propostasDisponiveis?.length">
            Fazer proposta
          </button>
          <button type="button" class="btn btn-danger btn-block" (click)="aceitarCancelarPedidoDaDisputa()"
                  [disabled]="processando">
            <i class="k-i-loading k-icon" *ngIf="processando"></i>
            Aceitar {{pedido.disputa.jaEntregou && pedido.disputa.reembolso ? 'reembolso' : 'cancelamento'}}
          </button>
          <button type="button" class="dispute-secondary-action" (click)="confirmeNaoAceitarCancelarPedidoDaDisputa()"
                  [disabled]="processando">
            Não aceitar {{pedido.disputa.jaEntregou && pedido.disputa.reembolso ? 'reembolso' : 'cancelamento'}}
          </button>
        </div>
      </section>

      <section class="dispute-section" *ngIf="pedido.proposta">
        <div class="dispute-section-title">
          <span class="dispute-section-icon dispute-section-icon-green"><i class="fas fa-handshake"></i></span>
          <h4>Fazer proposta</h4>
        </div>
        <div class="form-group">
          <label>Selecione a proposta</label>
          <kendo-dropdownlist class="form-control" name="acaoRetorno"
                              [data]="pedido.disputa.propostasDisponiveis" [filterable]="false"
                              [textField]="'descricao'" [valueField]="'id'"
                              [(ngModel)]="pedido.proposta.acao" required>
          </kendo-dropdownlist>
          <div class="invalid-feedback" *ngIf="!pedido.proposta.acao">Selecione a proposta</div>
        </div>
        <div class="form-group" *ngIf="pedido.proposta.acao">
          <label for="valor">Valor do <strong>{{pedido.proposta.acao.descricao}}</strong>
            <span class="text-muted">(máximo {{pedido.proposta.acao.valorMaximo | currency: 'BRL'}})</span>
          </label>
          <kendo-numerictextbox [attr.type]="'number'" id="valor" #valor="ngModel" name="valor"
                                class="form-control" format="c2" [(ngModel)]="pedido.proposta.valor"
                                [max]="pedido.proposta.acao.valorMaximo" [min]="1" required>
          </kendo-numerictextbox>
          <div class="invalid-feedback" *ngIf="pedido.proposta.valor != null">
            <span *ngIf="valor.errors?.maxValue">Valor máximo é {{pedido.proposta.acao.valorMaximo | currency: 'BRL'}}</span>
            <span *ngIf="valor.errors?.minValue">Valor da proposta inválido</span>
            <span *ngIf="valor.errors?.required">Informe o valor da proposta</span>
          </div>
        </div>
        <div class="dispute-inline-actions">
          <button type="button" class="btn btn-blue" (click)="enviePropostaDisputa()" [disabled]="processando">
            <i class="k-i-loading k-icon" *ngIf="processando"></i> Enviar proposta
          </button>
          <button type="button" class="btn btn-outline-secondary" [disabled]="processando"
                  (click)="pedido.proposta = null">Voltar</button>
        </div>
      </section>

      <section class="dispute-section" *ngIf="pedido.confirmarRejeitarDisputa">
        <div class="dispute-section-title">
          <span class="dispute-section-icon dispute-section-icon-red"><i class="far fa-times-circle"></i></span>
          <h4>Não aceitar solicitação</h4>
        </div>
        <div class="form-group" *ngIf="pedido.disputa.selecionarRazao">
          <label>Selecione a razão</label>
          <kendo-dropdownlist class="form-control" name="acaoRetorno"
                              [data]="pedido.disputa.razoesRejeitar" [filterable]="false"
                              [textField]="'descricao'" [valueField]="'id'"
                              [(ngModel)]="pedido.razaoRejeitar" required>
          </kendo-dropdownlist>
          <div class="invalid-feedback" *ngIf="!pedido.razaoRejeitar">Selecione uma razão</div>
        </div>
        <div class="form-group" *ngIf="pedido.disputa.selecionarRazao && pedido.disputa.justificativaLivre">
          <label for="motivoRejeitarLivre">Mais detalhes <span class="text-muted">(opcional)</span></label>
          <textarea class="form-control" minlength="5" maxlength="255" id="motivoRejeitarLivre"
                    name="motivoRejeitarLivre" [(ngModel)]="pedido.motivoRejeitarDisputa"
                    placeholder="Informe mais detalhes"></textarea>
        </div>
        <div class="form-group" *ngIf="!pedido.disputa.selecionarRazao">
          <label for="motivoRejeitar">Por qual motivo?</label>
          <textarea class="form-control" minlength="5" maxlength="255" required id="motivoRejeitar"
                    name="motivoRejeitar" [(ngModel)]="pedido.motivoRejeitarDisputa"
                    placeholder="Informe o motivo"></textarea>
          <div class="invalid-feedback">Informe um motivo para não aceitar o cancelamento</div>
        </div>
        <div class="dispute-inline-actions">
          <button type="button" class="btn btn-danger" (click)="naoAceitarCancelarPedidoDaDisputa()"
                  [disabled]="processando">
            <i class="k-i-loading k-icon" *ngIf="processando"></i> Confirmar
          </button>
          <button type="button" class="btn btn-outline-secondary" [disabled]="processando"
                  (click)="volteAceitarCancelarPedidoDisputa()">Voltar</button>
        </div>
      </section>
    </ng-container>

    <section class="dispute-section dispute-result"
             *ngIf="pedido.disputa.aguardandoProposta && !pedido.disputa.cellcoinChargeback">
      <div class="dispute-section-title">
        <span class="dispute-section-icon dispute-section-icon-green"><i class="far fa-clock"></i></span>
        <h4>Proposta enviada</h4>
      </div>
      <p>A loja enviou uma proposta e está aguardando a resposta do cliente.</p>
    </section>

    <div class="dispute-error" *ngIf="erroDisputa">
      <i class="fas fa-exclamation-circle"></i>
      <span>{{erroDisputa}}</span>
    </div>
  </div>
</form>
